import React from "react";
import KioskStatusBadge from "./KioskStatusBadge";
import { formatKioskTime } from "../hooks/kioskDashboard.helpers";

const displayDate = (value) => value || "N/D";

const KioskSessionTable = ({ rows = [], onReport }) => (
  <section className="bg-white border border-slate-200/80 rounded-2xl p-5 shadow-sm" aria-labelledby="kiosk-sessions-title">
    <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
      <div>
        <h2 id="kiosk-sessions-title" className="text-lg font-bold text-[#1D1F3F] font-display">Sesiones programadas</h2>
        <p className="text-xs text-slate-500 mt-1">Estado operativo, capacidad y colaboradores por grupo</p>
      </div>
      <span className="text-xs font-semibold text-slate-400">{rows.length} sesiones</span>
    </div>

    <div className="overflow-x-auto -mx-5 px-5">
      <table className="w-full min-w-[820px] border-collapse">
        <thead>
          <tr className="border-b border-slate-200/70">
            {[
              ["Fecha", "fecha"],
              ["Horario", "horario"],
              ["Grupo", "grupo"],
              ["Empleado", "empleado"],
              ["Estado", "estado"],
              ["Capacidad", "capacidad"],
              ["", "acciones"],
            ].map(([label, key]) => (
              <th key={key} className="pb-3 pr-4 text-left text-[10px] font-bold uppercase tracking-wider text-slate-400 font-display">
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {rows.length === 0 ? (
            <tr>
              <td colSpan="7" className="py-10 text-center text-sm font-medium text-slate-500">
                No hay sesiones programadas para este periodo.
              </td>
            </tr>
          ) : rows.map(row => {
            const canViewReport = row.status === "completed" || row.result === "completed";
            return (
              <tr key={row.sessionId} className="text-sm text-slate-700">
                <td className="py-3 pr-4 whitespace-nowrap font-medium">{displayDate(row.fecha)}</td>
                <td className="py-3 pr-4 whitespace-nowrap">{formatKioskTime(row.inicioLocal)} — {formatKioskTime(row.finLocal)}</td>
                <td className="py-3 pr-4">#{row.grupoId || row.calendarioKioscoGrupoId || "N/D"}</td>
                <td className="py-3 pr-4 font-semibold text-[#1D1F3F]">{row.nombre}</td>
                <td className="py-3 pr-4"><KioskStatusBadge status={row.status} /></td>
                <td className="py-3 pr-4 whitespace-nowrap">{row.ocupacion}/{row.capacidad}</td>
                <td className="py-3 text-right">
                  {canViewReport && (
                    <button
                      type="button"
                      onClick={() => onReport && onReport(row.sessionId)}
                      aria-label={`Ver reporte de ${row.nombre}`}
                      className="text-xs font-bold text-[#0075AC] hover:text-[#1D1F3F] underline underline-offset-2"
                    >
                      Ver reporte
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </section>
);

export default KioskSessionTable;
